module.exports = __webpack_public_path__ + "static/media/sGr.4350aaaa.png";